var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{\n  -webkit-font-smoothing:antialiased;\n  -moz-osx-font-smoothing:grayscale;\n  height:100%;\n}\nbody{\n  width:100%;\n  height:100%;\n  margin:0px;\n  padding:0px;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Thin.ttf")) + ") format('truetype');\n  font-weight:100;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-ExtraLight.ttf")) + ") format('truetype');\n  font-weight:200;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Light.ttf")) + ") format('truetype');\n  font-weight:300;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Regular.ttf")) + ") format('truetype');\n  font-weight:400;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Medium.ttf")) + ") format('truetype');\n  font-weight:500;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-SemiBold.ttf")) + ") format('truetype');\n  font-weight:600;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Bold.ttf")) + ") format('truetype');\n  font-weight:700;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-ExtraBold.ttf")) + ") format('truetype');\n  font-weight:800;\n}\n@font-face{\n  font-family:'Poppins';\n  src:url(" + escape(require("../../../styles/fonts/Poppins-Black.ttf")) + ") format('truetype');\n  font-weight:900;\n}\n@media only screen and (-webkit-min-device-pixel-ratio: 1.25), only screen and (min-device-pixel-ratio: 1.25), only screen and (-webkit-min-device-pixel-ratio: 2.0833333333333335), only screen and (min-resolution: 200dpi), only screen and (min-resolution: 1.25dppx){\n  html{\n    -webkit-font-smoothing:subpixel-antialiased;\n  }\n}\nhtml{\n  height:100%;\n  width:100%;\n  overflow:hidden;\n}\nbody{\n  height:100%;\n  width:100%;\n}\nbody{\n  color:var(--color-gray-900);\n  font-family:var(--fontFamily);\n  font-weight:var(--fontWeight-regular);\n  font-size:var(--fontSize-sm);\n  text-decoration:none;\n}\nsvg{\n  fill:none;\n}\np{\n  margin:0;\n  padding:0;\n}\ntable{\n  border-collapse:collapse;\n  border-spacing:0;\n}\ntr{\n  border-top:1px solid #c6cbd1;\n  background:#ffffff;\n}\ntr:nth-child(2n){\n  background:#f6f8fa;\n}\nth{\n  padding:6px 13px;\n  border:1px solid #dfe2e5;\n}\ntd{\n  padding:6px 13px;\n  border:1px solid #dfe2e5;\n}\nol{\n  padding:0;\n  margin:0;\n  list-style-type:decimal;\n  list-style-position:inside;\n}\nul{\n  padding:0;\n  margin:0;\n  list-style-type:disc;\n  list-style-position:inside;\n}\n#description-editor .ql-container{\n    height:auto;\n    border:1px solid transparent;\n    border-radius:8px;\n  }\n#description-editor:hover .ql-container,\n  #description-editor.active .ql-container{\n    border-color:#f1f1f1;\n  }\n#description-editor .ql-editor{\n    height:auto;\n    min-height:50px;\n  }\n#description-editor .ql-toolbar{\n    padding-bottom:3px;\n    display:none;\n    border:1px solid #f1f1f1;\n    border-radius:8px;\n  }\n#description-editor.active .ql-toolbar{\n    display:block;\n    margin-top:10px;\n    margin-bottom:10px;\n  }\n#description-editor .ql-formats{\n    margin:0 5px 5px 0;\n    border-radius:3px;\n    border:1px solid #e4e4e4;\n  }\n#newMessageEditor .ql-editor.ql-blank::before{\n    font-style:normal;\n    color:rgba(86, 104, 122, 0.6);\n    width:calc(100% - 150px);\n    height:20px;\n    text-overflow:ellipsis;\n    overflow:hidden;\n    white-space:nowrap;\n    padding-left:25px;\n  }\n#messageBeingEditedEditor .ql-editor{\n    padding-right:30px;\n  }\n#newMessageEditor .ql-editor{\n    padding:15px 130px 15px 42px;\n  }\n#newMessageEditor .ql-editor,\n  #newMessageEditor .ql-container{\n    height:auto;\n    max-height:300px;\n    font-size:14px;\n  }\n.timeline-day{\n    border-left:none !important;\n  }\n.timeline-month{\n    border-left:none !important;\n  }\n.rct-scroll{\n    overflow-x:hidden !important;\n  }\n.rct-calendar-header{\n    border:none !important;\n  }\n.rct-header-root{\n    border:none !important;\n    background:transparent !important;\n  }\nbody #ue_widget{\n    z-index:500 !important;\n  }\ninput,\ntextarea,\nselect,\nbutton,\np,\nlabel,\na{\n  font-family:inherit;\n  font-weight:inherit;\n  color:inherit;\n  text-decoration:none;\n}\nabbr[title]{\n  text-decoration:none;\n}\ntextarea:focus,\ninput:focus,\n*:focus{\n  outline:none;\n}\n::-webkit-scrollbar{\n  width:8px;\n  height:6px;\n}\n::-webkit-scrollbar-track{\n  background:transparent;\n}\n::-webkit-scrollbar-thumb{\n  background:rgba(0, 0, 0, 0.2);\n  border-radius:3px;\n}\n", ""]);

// exports
exports.locals = {
	"whiteTwoColor": "#ffffff",
	"whiteSevenColor": "#f8f8f8",
	"whiteFiveColor": "#eaeaea",
	"cloudyBlueColor": "#b9c3ce",
	"warmGreyThreeColor": "#777777",
	"warmGreyFourColor": "#8e8e8e",
	"warmGreyFiveColor": "#878787",
	"pinkishGreyThree": "#c9c9c9",
	"blackColor": "#000000",
	"mediumPinkTwo": "#ea5074",
	"darkPink": "#cf3256",
	"darkSixColor": "#0c1322",
	"darkNineColor": "#162432",
	"pigPink": "#ec8da3",
	"veryLightPink": "#fffefe",
	"maudlinOysterColor": "#c0c0c0",
	"haplessSnowColor": "#e2e2e2",
	"mercuryColor": "#e1e1e1",
	"pinkishGreyTwoColor": "#bcbcbc",
	"midnightColor": "#030a1b",
	"paleGreyThreeColor": "#f3f7fb",
	"paleGreyFourColor": "#ebf0f4",
	"porcelainColor": "#E9EAEB",
	"blackSqueezeColor": "#F2F7FB",
	"catskillWhite": "#DFE9F0",
	"redRibbonColor": "#E90242",
	"trueGreenColor": "#199800",
	"greyishColor": "#a3a3a3",
	"blueGreyThreeColor": "#6c839c",
	"slateThreeColor": "#425568",
	"blueGreyFourColor": "#687e97",
	"fiordColor": "#394D60",
	"darkSevenColor": "#101b25",
	"veryLightPinkColor": "#fffefe",
	"tomatoColor": "#eb2d2d",
	"bermudaGreyColor": "#6D839D",
	"paleCornflowerBlueColor": "#C8E3F9",
	"tangaroaColor": "#0F1C26",
	"hokiColor": "#68859E",
	"slateFourColor": "#4d6074",
	"greyBlueTwoColor": "#6a8199",
	"darkEightColor": "#13202c",
	"whiteColor": "#f1f1f1",
	"black05Color": "rgba(0, 0, 0, 0.05)",
	"black10Color": "rgba(0, 0, 0, 0.1)",
	"black15Color": "rgba(0, 0, 0, 0.15)",
	"black25Color": "rgba(0, 0, 0, 0.25)",
	"black20Color": "rgba(0, 0, 0, 0.2)",
	"black40Color": "rgba(0, 0, 0, 0.4)",
	"black55Color": "rgba(0, 0, 0, 0.55)",
	"black50Color": "rgba(0, 0, 0, 0.5)",
	"black60Color": "rgba(0, 0, 0, 0.6)",
	"whiteThreeColor": "#d8d8d8",
	"whiteFourColor": "#f9f9f9",
	"whiteSixColor": "#fcfcfc",
	"whiteTwo8Color": "rgba(255, 255, 255, 0.08)",
	"dodgerBlueColor": "#2f8fff",
	"blueGreyColor": "#7088a1",
	"blueGrey50Color": "rgba(112, 136, 161, 0.5)",
	"blueGreyTwoColor": "#788fa6",
	"bermudaGrayColor": "#7088A1",
	"blueyGreyColor": "#a3afbc",
	"blueyGrey60Color": "rgba(112, 136, 161, 0.6)",
	"clearBlueColor": "#1584fc",
	"darkGreyBlueColor": "#283949",
	"seafoamBlueColor": "#57bec7",
	"lightBlueColor": "#5ccff5",
	"babyBlueColor": "#b7d8ff",
	"cloudyBlue20Color": "rgba(185, 195, 206, 0.2)",
	"cloudyBlue30Color": "rgba(185, 195, 206, 0.3)",
	"cloudyBlue50Color": "rgba(185, 195, 206, 0.5)",
	"slate60Color": "rgba(86, 104, 122, 0.6)",
	"lightGreyColor": "#f8f9f9",
	"warmGreyColor": "#979797",
	"warmGrey5Color": "rgba(126, 126, 126, 0.05)",
	"warmGrey10Color": "rgba(126, 126, 126, 0.10)",
	"warmGrey15Color": "rgba(126, 126, 126, 0.15)",
	"lightGreenColor": "#42ffc0",
	"pinkishGreyColor": "#c8c8c8",
	"coralPinkColor": "#ff5c73",
	"macaroniAndCheeseColor": "#f8c233",
	"lipstickColor": "#e94149",
	"softPinkColor": "#f79dd0",
	"darkPeachColor": "#67b868",
	"cornFlowerColor": "#7850fc",
	"mediumPinkColor": "#e9579e",
	"paleRedColor": "#e54b4b",
	"darkTwoColor": "#1f2e3d",
	"silverColor": "#e4e5e5",
	"slateColor": "#56687a",
	"mortarColor": "rgba(91, 91, 91, 0.07)",
	"wisteriaColor": "#2d80eb",
	"wisteria15Color": "#2466bc",
	"wisteria15FlatColor": "#6ca6f1",
	"wisteria50Color": "#1b4d8d",
	"silverTwoColor": "#dedfdf",
	"darkGreyBlueTwoColor": "#293c4f",
	"bismarkColor": "#466784",
	"paleGreyColor": "#f3f3f4",
	"darkBlueGreyColor": "#111f2d",
	"darkThreeColor": "#1a2939",
	"darkFourColor": "#212035",
	"brownishGreyColor": "#636363",
	"greyish50Color": "rgba(177, 177, 177, 0.5)",
	"slateTwoColor": "#435567",
	"mangoColor": "#ffb02b",
	"darkMintColor": "#5cc984",
	"dodgerBlueTwoColor": "#56a0f6",
	"coralPinkTwoColor": "#ff575f",
	"duskColor": "#49627b",
	"gossamerColor": "#0ba765",
	"jungleGreenColor": "#25bc7c",
	"jetStreamColor": "#b2d5c9",
	"ghostColor": "#c6cbd1",
	"ironColor": "#dfe2e5",
	"aquaHazeColor": "#f6f8fa",
	"lochmaraColor": "#0576B9",
	"bahamaBlueColor": "#005E99",
	"tealishColor": "#37cfad",
	"darkSkyBlueColor": "#4A90E2",
	"outerSpaceColor90": "rgba(50, 60, 63, 0.9)",
	"brightBlueColor": "#007aff",
	"mediumCarmineColor": "#b63a3a",
	"orangePeelColor": "#f79a00",
	"greenHazeColor": "#009a59",
	"galleryColor": "#eaeaea",
	"elephantColor": "#10263c",
	"greyishBrownColor": "#4a4a4a",
	"blueyGreyTwo": "#a3b0be",
	"paleGreyTwoColor": "#dbe3ec",
	"metallicBlueColor": "#4c6580",
	"steelTwoColor": "#7c8895",
	"gridCellSize": "5px",
	"headerFontSize": "18px",
	"fontFamilyThree": "\"Poppins\", sans-serif",
	"topMenuHeight": "50px",
	"microFontSize": "9px",
	"smallerFontSize": "10px",
	"mediumSmallFontSize": "11px",
	"smallFontSize": "12px",
	"normalFontSize": "14px",
	"mediumFontSize": "16px",
	"headingFontSize": "19px",
	"largeFontSize": "20px",
	"largerFontSize": "24px",
	"thinFontWeight": "100",
	"lightFontWeight": "300",
	"regularFontWeight": "400",
	"mediumFontWeight": "500",
	"semiboldFontWeight": "600",
	"boldFontWeight": "700",
	"blackFontWeight": "900",
	"modalTransitionDuration": "90ms",
	"backdropEnteredOpacity": "0.33",
	"backdropOpacity": "0.9",
	"deactivatedOpacity": "0.85",
	"defaultFontFamily": "\"Poppins\", sans-serif",
	"fontFamilyTwo": "\"Poppins\", sans-serif",
	"defaultBorderWidth": "2px",
	"defaultOutlineWidth": "2px",
	"defaultBorderRadius": "4px",
	"largeBorderRadius": "8px",
	"largerBorderRadius": "18px",
	"defaultOutline": "0 0 0 2px rgba(126, 126, 126, 0.15)",
	"defaultPopoverShadow": "0 5px 15px 0 rgba(0, 0, 0, 0.25)",
	"headerHeight": "55px",
	"rightMenuWidth": "310px",
	"messageTextLineHeight": "20px",
	"leftMenuWidth": "300px",
	"cardDetailsHeight": "28px",
	"defaultTransition": "0.2s",
	"defaultTransitionAnimation": "0.5s cubic-bezier(0.2,1,0.1,1)",
	"defaultTransitionEasing": "cubic-bezier(0.2,1,0.1,1)",
	"mainMenuWidth": "300px",
	"defaultIconWidth": "12",
	"phoneBreakpointWidth": "425px",
	"tabletBreakpointWidth": "915px",
	"largeDesktop": "1600px"
};